import React from 'react';

import { AIFeature } from '@/common/interface';
import { useAIUsage } from '@/hooks/useAIUsage';
import AIFeatureLocked from '@/components/common/AIFeatureLocked';
import LoadingSpinner from '@/components/common/LoadingSpinner';

interface AIFeatureGuardProps {
    feature: AIFeature;
    children: React.ReactNode;
}

/** Route wrapper that shows a locked page when the learner's plan does not include the feature. */
const AIFeatureGuard: React.FC<AIFeatureGuardProps> = ({ feature, children }) => {
    const { isReady, isLocked } = useAIUsage();

    if (!isReady) {
        return <LoadingSpinner />;
    }
    if (isLocked(feature)) {
        return <AIFeatureLocked feature={feature} />;
    }
    return <>{children}</>;
};

export default AIFeatureGuard;
